import CookieService from '~/services/cookies'
import EventsService from '~/services/events'
import { RouteService } from '~/services/route/service'

export enum NewFeatureSection {
	WALL = 'trip-wall-3-mar-26',
	ACTIVITIES = 'trips-activity-onboarding-15-4-26',
	IDEAS = 'trips-store-3-feb-25',
	INDISPENSABLES = 'trip-tore-indispensables-28-apr-26',
}

export type NewFeatureDialogProps = {
	cookie: string
	image: string
	title: string
	description: string
	buttonText: string
	isXS: boolean
}

export class NewFeatureActions {
	static openDialog(props: NewFeatureDialogProps): void {
		const newFeatureAccepted = CookieService.getCookie(props.cookie as any)
		if (newFeatureAccepted) return
		setTimeout(() => {
			EventsService.emitOpenNewFeature(props)
			this.saveCookie(props.cookie)
		}, 150)
	}

	static openProfileWizard(routeName: string): void {
		const SIMPLE_WIZARD_ROUTES = ['trip-itinerary_id-dashboard']
		const normalizedRoute = RouteService.getNormalizedRouteName(routeName as string)
		const openSimple = SIMPLE_WIZARD_ROUTES.some((simpleRoute) => simpleRoute === normalizedRoute)
		EventsService.emitOpenProfileWizard(openSimple)
	}

	private static saveCookie(cookie: string): void {
		const expirationDays: number = 365
		CookieService.setAccepted(cookie, true, expirationDays)
	}
}
